// /**
//  * Centers - Detail
//  */

// React
import React, { useEffect, useState } from 'react';

// Redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Store } from '../../../redux/reducers';
import {
  getUsersByCenterIdAction,
  getUsersBeAdminCenterAction,
  updateCenterAdminActions,
} from '../actions';

// Selector
import { createStructuredSelector } from 'reselect';
import {
  makeSelectError,
  makeSelectLoading,
  makeSelectCountList,
  makeSelectUsersListByCenterId,
  makeSelectUsersListBeCenter,
} from '../selectors';

// UI
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import {
  Paper,
  Grid,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiAccountOutline,
  mdiPlus,
  mdiArrowRight,
  mdiStore24Hour,
  mdiStore,
  mdiPhone,
  mdiHomeCityOutline, mdiMapMarkerOutline, mdiMapOutline,
} from '@mdi/js';

// Helper
import { formaterPhoneNumber } from '../../../utils/helpers';

// Components
import ListUser from './list-users';
import AddUser from './add-user';
import MapPosition from './mapPosition';

// Type
// import {SelectorPropsDetail, PropsDetail, PayloadUpdate} from '../interfaces';
import { PropsDetail, SelectorPropsDetail, PayloadUpdate } from '../interfaces';
//
// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    paper: {
      marginTop: theme.spacing(4),
      padding: theme.spacing(4),
      border: '1px solid #ddd',
    },
    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      '& > *': {
        margin: theme.spacing(0, 1),
      },
    },
  })
);

function Detail(props: PropsDetail) {
  const classes = useStyles();
  const [openAddUser, setOpenAddUser] = useState(false as boolean);
  const [openMap, setOpenMap] = useState(false as boolean);

  useEffect(() => {
    props.usersByCenterIdDispatch({
      'centersId.equals': props.data.id,
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleClose = () => {
    setOpenAddUser(false);
  };

  return (
    <>
      <Grid container spacing={5} alignItems="flex-start">
        <Grid item xs={12}>
          <Paper
            elevation={3}
            className={classes.paper}
            variant="elevation"
            square
          >
            <Grid container spacing={3}>
              <Grid item xs={12} sm={4}>
                <div className={classes.item}>
                  <Icon path={mdiStore} size={1} />
                  {`نام مرکز:  `}
                  <span>{props.data?.name}</span>
                </div>
              </Grid>
              <Grid item xs={12} sm={4}>
                <div className={classes.item}>
                  <Icon path={mdiStore24Hour} size={1} />
                  {`کد مرکز:`}
                  <span>{props.data.code}</span>
                </div>
              </Grid>

              <Grid item xs={12} sm={4}>
                <div className={classes.item}>
                  <Icon path={mdiPhone} size={1} />
                  {`شماره تماس:  `}
                  <span>{formaterPhoneNumber(props.data.phoneNumber)}</span>
                </div>
              </Grid>
              <Grid item xs={12} sm={4}>
                <div className={classes.item}>
                  <Icon path={mdiAccountOutline} size={1} />
                  {` کاربر مرکز:  `}
                  <span>{props.data.adminId}</span>
                </div>
              </Grid>
              <Grid item xs={12} sm={4}>
                <div className={classes.item}>
                  <Icon path={mdiMapOutline} size={1} />
                  <Button
                    variant="text"
                    color="primary"
                    size="small"
                    onClick={() => setOpenMap(true)}
                  >
                    {`آدرس مرکز روی نقشه`}
                  </Button>
                </div>
              </Grid>

              <Grid item xs={12} sm={4}>
                <div className={classes.item}>
                  <Icon path={mdiHomeCityOutline} size={1} />
                  {`استان:`}
                  <span>{props.data.province}</span>
                </div>
              </Grid>
              <Grid item xs={12} sm={4}>
                <div className={classes.item}>
                  <Icon path={mdiHomeCityOutline} size={1} />
                  {`شهر:`}
                  <span>{props.data.city}</span>
                </div>
              </Grid>  <Grid item xs={12}>
                <div className={classes.item}>
                  <Icon path={mdiMapMarkerOutline} size={1} />
                  {`آدرس:`}
                  <span>{props.data.address}</span>
                </div>
              </Grid>
            </Grid>
          </Paper>
        </Grid>

        <Grid container item xs={12} direction="row-reverse">
          <Button
            variant="contained"
            color="secondary"
            startIcon={<Icon path={mdiPlus} size={1} />}
            onClick={() => setOpenAddUser(true)}
          >{`اضافه کردن کاربر جدید`}</Button>
        </Grid>

        <Grid item xs={12}>
          <Paper>
            {
              <>
                <ListUser
                  data={props.usersByCenterId}
                  centerId={props.data.id}
                  updatecenterDispatch={() => console.log('update')}
                />
              </>
            }
          </Paper>
        </Grid>
      </Grid>
      <Dialog
        fullScreen
        open={openAddUser}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div>{`اختصاص کاربر به شرکت ${props.data?.name}`}</div>
          <Button aria-label="details" size="medium" onClick={handleClose}>
            <Icon path={mdiArrowRight} size={1} />
            {`بازگشت`}
          </Button>
        </DialogTitle>
        <DialogContent>
          <AddUser
            handleClose={handleClose}
            usersList={props.usersBeAdminCenter}
            usersBeAdminCenterDispatch={props.usersBeAdminCenterDispatch}
            updateCenterDispatch={props.updateCenterAdminDispatch}
            centerId={props.data.id}
          />
        </DialogContent>
      </Dialog>

      <Dialog open={openMap} onClose={() => setOpenMap(false)}>
        <DialogTitle>آدرس مرکز روی نقشه </DialogTitle>
        <DialogContent style={{ width: '600px' }}>
          <MapPosition
            zoom={14}
            center={[props.data.lat, props.data.lon]}
            position={[props.data.lat, props.data.lon]}
            setLatlng={(latLng: { lat: number; lng: number }) => null}
          />
        </DialogContent>
      </Dialog>
    </>
  );
}

const mapStateToProps = createStructuredSelector<Store, SelectorPropsDetail>({
  usersByCenterId: makeSelectUsersListByCenterId(),
  usersBeAdminCenter: makeSelectUsersListBeCenter(),
  count: makeSelectCountList(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    usersByCenterIdDispatch: (payload: Object) =>
      dispatch(getUsersByCenterIdAction(payload)),
    usersBeAdminCenterDispatch: (payload: Object) =>
      dispatch(getUsersBeAdminCenterAction(payload)),
    updateCenterAdminDispatch: (payload: PayloadUpdate) =>
      dispatch(updateCenterAdminActions(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Detail);
